import React from 'react';
import { theme } from 'antd';
import ThemeToggle from './ThemeToggle';

interface AuthPageShellProps {
  children: React.ReactNode;
}

/** Centered auth layout with theme toggle in the top-right corner. */
const AuthPageShell: React.FC<AuthPageShellProps> = ({ children }) => {
  const { token } = theme.useToken();

  return (
    <div
      className="cp-auth-page"
      style={{
        minHeight: '100vh',
        background: token.colorBgLayout,
        position: 'relative',
      }}
    >
      <div className="cp-auth-theme-toggle">
        <ThemeToggle />
      </div>
      <div
        className="cp-auth-page__content"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AuthPageShell;
